import React from 'react'
import './ExplanationScreen.css'
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Nav from '../../components/Nav/Nav';
import VerifyEmailComponent from '../../components/rememberverifyemail';
import { auth } from '../../firebase';
import { Helmet } from 'react-helmet';
import FAQcomponent from '../../components/FAQcomponent/FAQcomponent';
import { IoIosArrowDropright } from 'react-icons/io'

const HOW_TO_LINKS = [
  { title: 'How create a Premium Message and sell premium messages 💰', url: 'https://www.canva.com/design/DAGGK4tnlHw/1uj8QufsOUZ6E-9nWVYquQ/edit?utm_content=DAGGK4tnlHw&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton' },
  { title: 'How market your Premium Messages on Premsi 🔥', url: 'https://www.canva.com/design/DAGMX5HRABM/WlhYireOsGOLYwMh84p8Cg/edit?utm_content=DAGMX5HRABM&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton' },
  { title: 'How create free and paid subscription groups on Premsi 🫂', url: 'https://www.canva.com/design/DAGMX7uYiG0/NiFT64jFxWRGWpzGbIM_WQ/edit?utm_content=DAGMX7uYiG0&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton' },
  { title: 'How create custom in chat Premium Messages 🎉', url: 'https://www.canva.com/design/DAGMX7vKuJQ/suqgkX2lsP3lTf_Kh4Jj_w/edit?utm_content=DAGMX7vKuJQ&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton' },
]

function ExplanationScreen() {
    const navigate = useNavigate()

    return (
        <>
            <Helmet>
                {/* Open Graph Meta Tags */}
                <meta property="og:title" content="What is Premsi ? | Sell and market digital content in seconds" />
                <meta property="og:description" content="What is Premsi ? | Sell and market digital content in seconds . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <meta property="og:url" content="https://premsi.com/presentation" />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/premsicom-accb2.appspot.com/o/P1-min.png?alt=media&token=1fbb167c-ed04-444c-b45c-dc411cdbb16f" />
                <meta property="og:site_name" content="Premsi - sell digital content" />

                <title>What is Premsi ? | Sell and market digital content in seconds</title>
                <meta name="description" content="What is Premsi ? | Sell and market digital content in seconds . Premsi lets you easily sell and market your Videos/Pics/PDFs/Groups and soon courses. All for free and in 1 minute." />
                <link rel="canonical" href="https://premsi.com/presentation" />
            </Helmet>
            <Nav />
            {auth.currentUser === null || auth.currentUser === undefined || auth.currentUser.emailVerified === true ? null : <VerifyEmailComponent />}
            <div className="explanation-page">
                {/*<section className="explanation-page__hero">
                    <img className="explanation-page__hero-img" loading="lazy" src={require('../../images/1pres.webp')} alt="Premsi.com presentation explanation" />
                </section>*/}

                <section className="explanation-page__intro">
                    <div className="explanation-page__intro-title-row">
                        <h1 className="explanation-page__title">What is Premsi and how does it work?</h1>
                        <img className="explanation-page__logo" loading="lazy" src={require('../../images/pblue-min.webp')} alt="Premsi.com logo app icon" />
                    </div>
                    <p className="explanation-page__tagline">Premsi is the social media where you can post, market and sell all your digital content in our App <span className="font-body-inline">+</span> Website in 30sec 🔥</p>

                    <div className="explanation-page__link-grid">
                        {HOW_TO_LINKS.map((item) => (
                            <button
                                key={item.url}
                                type="button"
                                className="explanation-page__link-card"
                                onClick={() => window.open(item.url, '_blank')}
                            >
                                <span className="explanation-page__link-card-text">{item.title}</span>
                                <IoIosArrowDropright className="explanation-page__link-card-icon" size={28} aria-hidden />
                            </button>
                        ))}
                    </div>
                </section>

                <div className="explanation-page__faq">
                    <FAQcomponent />
                </div>

                <section className="explanation-page__referral">
                    <div className="explanation-page__referral-inner">
                        <div className="explanation-page__referral-content">
                            <h2 className="explanation-page__referral-title">Refer friends <span className="font-body-inline">&</span> receive 5<span className="font-body-inline">%</span> of their spendings for life 🔥</h2>
                            <p className="explanation-page__referral-text">Whenever they subscribe to Premsi<span className="font-body-inline">+</span>, tip someone or buy a premium message you'll earn.</p>
                            <button type="button" className="explanation-page__referral-btn" onClick={() => navigate('/profile')}>Refer a friend</button>
                        </div>
                        <div className="explanation-page__referral-media">
                            <img loading="lazy" className="explanation-page__referral-img" src={require('../../images/referral.webp')} alt="Premsi.com referral bonus" />
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}

export default ExplanationScreen
